import type { SuitabilityAnswers } from './answers';
import type { SuitabilityTestDefinition } from 'src/suitability/engine/types';
import {
  getCoherenceErrors,
  isBlock1Complete,
  isBlock2Complete,
  isBlock3Complete,
} from './coherence';
import { StepPreData } from './step-pre-data';
import { StepBlock1 } from './step-block1';
import { StepBlock2 } from './step-block2';
import { StepBlock3 } from './step-block3';

/**
 * Respuestas iniciales del cuestionario. Solo P5 arranca con estado (mapa de
 * checkboxes de experiencia); el resto de preguntas empiezan sin responder.
 */
export const INITIAL_ANSWERS: SuitabilityAnswers = {
  p5: {
    '5a': false,
    '5b': false,
    '5c': false,
    '5d': false,
    '5e': false,
    '5f': false,
    '5g': false,
    '5h': false,
    '5i': false,
  },
};

/** Test de idoneidad MiFID II de Wio Capital, versión 1. */
export const wioCapitalV1: SuitabilityTestDefinition<SuitabilityAnswers> = {
  company: 'wio-capital',
  version: 'v1',
  initialAnswers: INITIAL_ANSWERS,
  steps: [
    {
      stepKey: 'preData',
      Component: StepPreData,
      isComplete: (answers) => !!answers.ageRange,
    },
    {
      stepKey: 'block1',
      Component: StepBlock1,
      isComplete: isBlock1Complete,
    },
    {
      stepKey: 'block2',
      Component: StepBlock2,
      isComplete: (answers) =>
        isBlock2Complete(answers) && getCoherenceErrors(answers).length === 0,
    },
    {
      stepKey: 'block3',
      Component: StepBlock3,
      isComplete: isBlock3Complete,
    },
  ],
};
